import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const LiveChat = (props?: SvgIconProps) => (
  <SvgIcon width="100%" height="100%" viewBox="0 0 32 32" {...props}>
    <path d="m5 13c0-6.07513 4.92487-11 11-11 6.0751 0 11 4.92487 11 11v1.126c1.7252.4441 3 2.0102 3 3.874v4c0 2.2091-1.7909 4-4 4-.2306 0-.4567-.0195-.6766-.057-1.3692 2.6032-4.1589 4.2001-7.1235 4.0471-.0657.0066-.1324.0099-.1999.0099h-2c-1.1046 0-2-.8954-2-2s.8954-2 2-2h2c1.0443 0 1.9017.8004 1.9921 1.8212 1.4729-.3808 2.7535-1.3499 3.5033-2.7022-.9118-.7331-1.4954-1.8579-1.4954-3.119v-4c0-1.8638 1.2748-3.4299 3-3.874v-1.126c0-4.97056-4.0294-9-9-9s-9 4.02944-9 9v1.126c1.72523.4441 3 2.0102 3 3.874v4c0 2.2091-1.79086 4-4 4s-4-1.7909-4-4v-4c0-1.8638 1.27477-3.4299 3-3.874z" />
  </SvgIcon>
);

export default LiveChat;
